<div class="modal-header">
  <h4 class="modal-title">{{ modal_header }}</h4>
  <button class="btn-close" type="button" aria-label="Close" (click)="dismissModal()"></button>
</div>

<div class="modal-body py-0">
  <span>{{ modal_body }}</span>
</div>

<div class="modal-footer border-top-0">
  <button class="btn btn-primary px-md-5" type="button" (click)="dismissModal()">
    {{ ('ok' | translate).toUpperCase() }}
  </button>
</div>
